const noEsItems = [
  {
    icon: 'ri-folder-open-line',
    label: 'Un directorio de radios',
    desc: 'No somos una lista. Somos interacción real entre oyentes y locutores.',
  },
  {
    icon: 'ri-play-circle-line',
    label: 'Solo streaming de audio',
    desc: 'No solo se escucha. Se participa, se compite, se crece y se monetiza.',
  },
];

const pilares = [
  { icon: 'ri-share-circle-line', label: 'Red Social', desc: 'Conexión real entre radios, locutores y oyentes en un solo ecosistema.' },
  { icon: 'ri-group-line', label: 'Comunidad', desc: 'Miles de oyentes interactuando, enviando saludos y participando en vivo.' },
  { icon: 'ri-user-heart-line', label: 'Seguidores', desc: 'Cada radio construye su base de fans con herramientas de fidelización.' },
  { icon: 'ri-mic-line', label: 'Locutores', desc: 'Perfiles públicos, programas propios y conexión directa con su audiencia.' },
  { icon: 'ri-calendar-check-line', label: 'Programas', desc: 'Parrilla de programación completa con notificaciones y recordatorios.' },
  { icon: 'ri-money-dollar-circle-line', label: 'Monetización', desc: 'Publicidad propia, red RFW, marketplace, sponsors y revenue share.' },
  { icon: 'ri-trophy-line', label: 'Gamificación', desc: 'Niveles, insignias, rankings y recompensas que enganchan a los oyentes.' },
];

export default function AuditoriaLandingSection() {
  return (
    <section id="auditoria-landing" className="relative py-20 md:py-28 overflow-hidden bg-background-100">
      {/* Ambient glows */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-rose-500/2 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-amber-500/2 rounded-full blur-3xl pointer-events-none"></div>

      {/* Dot grid */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.015]" style={{
        backgroundImage: 'radial-gradient(circle, currentColor 1px, transparent 1px)',
        backgroundSize: '20px 20px',
      }}></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        {/* ── Header ── */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-100/80 border border-slate-200/70 text-slate-600 text-xs font-semibold mb-5">
            <i className="ri-eye-line text-xs"></i>
            ¿Qué es realmente RFW?
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Mucho más que una{' '}
            <span className="text-slate-400 line-through decoration-slate-400 decoration-2">radio online</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            RadioFrecuenciaWeb no es un directorio ni una app de streaming. Es la primera red social diseñada exclusivamente para el ecosistema radial hispano.
          </p>
        </div>

        {/* ── Desktop split layout ── */}
        <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
          {/* ── Left: No es... ── */}
          <div className="lg:w-[38%] flex flex-col gap-4 md:gap-5">
            <div className="flex items-center gap-2.5 mb-1">
              <div className="w-8 h-8 rounded-lg bg-slate-200/80 flex items-center justify-center">
                <i className="ri-close-line text-slate-500 text-sm"></i>
              </div>
              <span className="text-slate-500 text-xs font-bold uppercase tracking-widest">No es</span>
            </div>

            {noEsItems.map((item) => (
              <div
                key={item.label}
                className="group relative rounded-2xl border border-slate-200/70 bg-background-50 p-5 md:p-6 transition-all duration-300 hover:border-slate-300/80"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-slate-100 text-slate-400 shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div className="min-w-0">
                    <h4 className="text-foreground-400 text-sm font-semibold line-through decoration-slate-300 decoration-1">
                      {item.label}
                    </h4>
                    <p className="mt-1.5 text-foreground-500 text-[11px] leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                  {/* X badge */}
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-slate-200/80 text-slate-500 shrink-0">
                    <i className="ri-close-line text-xs"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Divider arrow desktop ── */}
          <div className="hidden lg:flex items-center justify-center shrink-0">
            <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
              <i className="ri-arrow-right-line text-background-50 text-lg"></i>
            </div>
          </div>

          {/* ── Right: Es... ── */}
          <div className="lg:flex-1">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-check-line text-background-50 text-sm"></i>
              </div>
              <span className="text-accent-600 text-xs font-bold uppercase tracking-widest">Es</span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {pilares.map((pilar) => (
                <div
                  key={pilar.label}
                  className="group relative rounded-2xl border border-accent-200/60 bg-background-50 p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300/80 hover:shadow-lg hover:shadow-accent-500/5"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100/80 text-accent-600 shrink-0 transition-all duration-300 group-hover:bg-accent-500 group-hover:text-background-50">
                      <i className={`${pilar.icon} text-lg`}></i>
                    </div>
                    <div className="min-w-0">
                      <h4 className="text-foreground-950 font-bold text-sm mb-1">{pilar.label}</h4>
                      <p className="text-foreground-500 text-[11px] leading-relaxed">{pilar.desc}</p>
                    </div>
                    {/* Check badge */}
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-600 shrink-0 transition-all duration-300 group-hover:bg-accent-500 group-hover:text-background-50">
                      <i className="ri-check-line text-[10px]"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Bottom trust strip ── */}
        <div className="mt-12 pt-8 border-t border-background-200/70">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {[
              'Experiencia nativa mobile',
              'Experiencia nativa desktop',
              'Diseñado para radios hispanas',
            ].map((text) => (
              <span
                key={text}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200/70 text-foreground-600 text-[11px] font-medium whitespace-nowrap"
              >
                <i className="ri-checkbox-circle-fill text-accent-500 text-xs"></i>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}